export default function HomeLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <main className="flex flex-col w-full  h-full  main-home items-center ">
        <section className=" w-full mx-auto flex-1 flex flex-col items-center ">{children}</section>
      </main>
    </>
  );
}
